var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-multline",staticStyle:{"font-weight":"normal"},on:{"click":function($event){return _vm.column.click(_vm.row)}}},[_c('p',[_vm._v(_vm._s(_vm.row[_vm.column.field])+" "),_vm._l((_vm.column.lines),function(field,index){return _c('span',{key:index},[_c('br'),_vm._v(_vm._s(_vm.row[field])+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }